import { render, staticRenderFns } from "./AddRequestComponent.vue?vue&type=template&id=5fa9bbd2"
import script from "./AddRequestComponent.vue?vue&type=script&lang=js"
export * from "./AddRequestComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports